"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-114c85cf"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = ["onclick"];
const index_1 = require("../../../utils/index");
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    setup(__props) {
        const userInfo = (0, vue_3.reactive)({
            icon: "",
            name: "",
        });
        (0, vue_3.onMounted)(() => {
            var _a;
            const data = JSON.parse(localStorage.getItem('userInfo'));
            if (data) {
                userInfo.icon = (_a = data === null || data === void 0 ? void 0 : data.userName) === null || _a === void 0 ? void 0 : _a.slice(0, 1);
                userInfo.name = data === null || data === void 0 ? void 0 : data.userName;
            }
        });
        return (_ctx, _cache) => {
            const _component_a_avatar = (0, vue_2.resolveComponent)("a-avatar");
            const _component_CaretDownOutlined = (0, vue_2.resolveComponent)("CaretDownOutlined");
            const _component_a_menu_item = (0, vue_2.resolveComponent)("a-menu-item");
            const _component_a_menu = (0, vue_2.resolveComponent)("a-menu");
            const _component_a_dropdown = (0, vue_2.resolveComponent)("a-dropdown");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(_component_a_avatar, {
                    size: "large",
                    class: "avatar"
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(userInfo.icon), 1)
                    ]),
                    _: 1
                }),
                (0, vue_2.createVNode)(_component_a_dropdown, { class: "username" }, {
                    overlay: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createVNode)(_component_a_menu, null, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(_component_a_menu_item, null, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createElementVNode)("a", {
                                            href: "#",
                                            onclick: () => { (0, vue_2.unref)(index_1.logOut)(); }
                                        }, "退出登录", 8, _hoisted_1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("a", {
                            onClick: _cache[0] || (_cache[0] = (0, vue_2.withModifiers)(() => { }, ["prevent"]))
                        }, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(userInfo.name) + " ", 1),
                            (0, vue_2.createVNode)(_component_CaretDownOutlined)
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
